/**
 * extract main domain (last 2 parts)
 * @param hostname 
 * @returns main domain (e.g. localhost -> localhost, sub.example.com -> example.com)
 */
export const getMainDomain = (hostname: string): string => {
	if (hostname.includes('localhost')) return 'localhost';

	const parts = hostname.split('.');
	if (parts.length > 2) {
		return parts.slice(-2).join('.');
	}
	return hostname;
}